module.exports = "/group_create-a4c8c40aecc0ed3cd51f61a979aa9316.svg";